module.exports = __webpack_public_path__ + "static/media/9DESA14.d48f07d9.jpg";